<template>
  <div class="node-type-picker grid">
    <div
      v-for="(nodeType, i) in NODE_TYPES"
      :key="'node-'+i"
      class="grid-btn"
      @click="$emit('select', nodeType)"
    >{{$consts.NODE_LABELS_FOR_PATH_TYPE[nodeType]}}</div>
  </div>
</template>

<script>
export default {
  name: "nodes",
  components: {},
  data: () => ({
    loading: true,
    errors: [],
    filteredLocations: [],
    locations: [],
    selected: null,
    filter: "",
    NODE_TYPES: [
      "panels",
      "mccs",
      "vfds",
      "breakers",
      "starters",
      "softstarts",
      "distribution_panelboards",
      "switchboards",
      "transformers",
      "disconnect_switches",
      "fuses",
      "auxnodes"
    ]
  }),
  methods: {
    applyFilter() {
      this.filteredLocations = this.locations.filter(location =>
        location.title.toLowerCase().includes(this.filter.toLowerCase())
      );
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(2, 180px);
  column-gap: 5px;
  row-gap: 5px;
}

.grid-btn {
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 4px 0px #aaa;
  transition: background 0.5s;

  &:hover {
    background-color: #eee;
    transition: background 0s;
  }
}
</style>